import React from 'react';
import HomePage from '../pages/HomePage';
import GamesPage from '../pages/GamesPage';
import ViewUploadPage from '../pages/ViewUploadPage';
import {
    AppRegistration,
    UploadFileRounded,
    Gamepad,
    Home,
    Search,
    Notifications,
    AdminPanelSettings,
    Newspaper,
} from '@mui/icons-material';
import CreateUploadPage from '../pages/CreateUploadPage';
import LoginPage from '../pages/LoginPage';
import Login from '@mui/icons-material/Login';
import RegisterPage from '../pages/RegisterPage';
import SearchPage from '../pages/SearchPage';
import AdminPage from '../pages/AdminPage';
import SuspendedPage from '../pages/SuspendedPage';
import ViewUserPage from '../pages/ViewUserPage';
import { User } from '../workers/ApiWorker';
import FileUploadPage from '../pages/FileUploadPage';
import NotificationsPage from '../pages/NotificationsPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import VerifyAccountPage from '../pages/VerifyAccountPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import TermsOfServicePage from '../pages/TermsOfServicePage';
import BlogPage from '../pages/BlogPage';
import CreateBlogPage from '../pages/CreateBlogPage';
import ViewBlogPage from '../pages/ViewBlogPage';

export interface LinksProps {
    name: string;
    path: string;
    icon: JSX.Element;
    showIconBreadcrumb: boolean;
    page: JSX.Element;
    sideBar: boolean;
}

export const NotificationsLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: '',
        path: '/notifications',
        icon: <Notifications />,
        showIconBreadcrumb: false,
        page: (
            <NotificationsPage
                isMobile={isMobile}
                padding={padding}
                user={user}
            />
        ),
        sideBar: false,
    };
};

export const GamesLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Games',
        path: '/games',
        icon: <Gamepad />,
        showIconBreadcrumb: true,
        page: (
            <GamesPage
                isMobile={isMobile}
                padding={padding}
                user={user}
                width={width}
            />
        ),
        sideBar: true,
    };
};

export const HomeLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Home',
        path: '/',
        icon: <Home />,
        showIconBreadcrumb: true,
        page: <HomePage isMobile={isMobile} padding={padding} user={user} />,
        sideBar: true,
    };
};

export const ViewUploadsLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'ViewUploadPage',
        path: ':username/:uuid',
        icon: <Gamepad />,
        showIconBreadcrumb: false,
        page: (
            <ViewUploadPage
                isMobile={isMobile}
                padding={padding}
                user={user}
                width={width}
            />
        ),
        sideBar: false,
    };
};

export const ViewUserLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'ViewUserPage',
        path: ':username',
        icon: <Gamepad />,
        showIconBreadcrumb: false,
        page: (
            <ViewUserPage
                isMobile={isMobile}
                padding={padding}
                user={user}
                width={width}
            />
        ),
        sideBar: false,
    };
};

export const CreateUploadsLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Upload',
        path: '/upload',
        icon: <UploadFileRounded />,
        showIconBreadcrumb: false,
        page: (
            <CreateUploadPage
                isMobile={isMobile}
                padding={padding}
                user={user}
            />
        ),
        sideBar: true,
    };
};

export const AdminLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Admin',
        path: '/admin',
        icon: <AdminPanelSettings />,
        showIconBreadcrumb: false,
        page: <AdminPage isMobile={isMobile} padding={padding} user={user} />,
        sideBar: false,
    };
};

export const ResetPasswordLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'ResetPassword',
        path: '/reset-password',
        icon: <Login />,
        showIconBreadcrumb: false,
        page: <ResetPasswordPage />,
        sideBar: false,
    };
};

export const VerifyAccountLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'VerifyAccount',
        path: '/verify-account',
        icon: <Login />,
        showIconBreadcrumb: false,
        page: <VerifyAccountPage />,
        sideBar: false,
    };
};

export const ForgotPasswordLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'ForgotPassword',
        path: '/forgot-password',
        icon: <Login />,
        showIconBreadcrumb: false,
        page: <ForgotPasswordPage />,
        sideBar: false,
    };
};

export const LoginLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Login',
        path: '/login',
        icon: <Login />,
        showIconBreadcrumb: false,
        page: <LoginPage />,
        sideBar: false,
    };
};

export const RegisterLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Register',
        path: '/register',
        icon: <AppRegistration />,
        showIconBreadcrumb: false,
        page: <RegisterPage isMobile={isMobile} />,
        sideBar: false,
    };
};

export const Searchink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Search',
        path: '/search',
        icon: <Search />,
        showIconBreadcrumb: false,
        page: <SearchPage isMobile={isMobile} padding={padding} user={user} />,
        sideBar: false,
    };
};

export const SuspendedLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Suspended',
        path: '/suspended',
        icon: <Search />,
        showIconBreadcrumb: false,
        page: <SuspendedPage isMobile={isMobile} padding={padding} />,
        sideBar: false,
    };
};

export const FileUploadLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'FileUpload',
        path: '/file-upload',
        icon: <Gamepad />,
        showIconBreadcrumb: false,
        page: (
            <FileUploadPage isMobile={isMobile} padding={padding} user={user} />
        ),
        sideBar: false,
    };
};

export const PrivacyPolicyLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: '',
        path: '/privacy-policy',
        icon: <Notifications />,
        showIconBreadcrumb: false,
        page: (
            <PrivacyPolicyPage
                isMobile={isMobile}
                padding={padding}
                user={user}
            />
        ),
        sideBar: false,
    };
};

export const TermsOfServiceLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: '',
        path: '/terms-of-service',
        icon: <Notifications />,
        showIconBreadcrumb: false,
        page: (
            <TermsOfServicePage
                isMobile={isMobile}
                padding={padding}
                user={user}
            />
        ),
        sideBar: false,
    };
};

export const BlogLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Blog',
        path: '/blog',
        icon: <Newspaper />,
        showIconBreadcrumb: false,
        page: <BlogPage isMobile={isMobile} padding={padding} user={user} />,
        sideBar: false,
    };
};

export const BlogCreateLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Blog',
        path: '/create-blog',
        icon: <Newspaper />,
        showIconBreadcrumb: false,
        page: (
            <CreateBlogPage isMobile={isMobile} padding={padding} user={user} />
        ),
        sideBar: false,
    };
};

export const ViewBlogLink = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps => {
    return {
        name: 'Blog',
        path: '/blog/:slug',
        icon: <Newspaper />,
        showIconBreadcrumb: false,
        page: (
            <ViewBlogPage isMobile={isMobile} padding={padding} user={user} />
        ),
        sideBar: false,
    };
};

export const links = (
    isMobile: boolean,
    padding?: number,
    user?: User,
    width?: number
): LinksProps[] => {
    return [
        HomeLink(isMobile, padding, user, width),
        GamesLink(isMobile, padding, user, width),
        ViewUserLink(isMobile, padding, user, width),
        ViewUploadsLink(isMobile, padding, user, width),
        CreateUploadsLink(isMobile, padding, user, width),
        LoginLink(isMobile, padding, user, width),
        RegisterLink(isMobile, padding, user, width),
        ResetPasswordLink(isMobile, padding, user, width),
        ForgotPasswordLink(isMobile, padding, user, width),
        VerifyAccountLink(isMobile, padding, user, width),
        Searchink(isMobile, padding, user, width),
        AdminLink(isMobile, padding, user, width),
        SuspendedLink(isMobile, padding, user, width),
        FileUploadLink(isMobile, padding, user, width),
        NotificationsLink(isMobile, padding, user, width),
        PrivacyPolicyLink(isMobile, padding, user, width),
        TermsOfServiceLink(isMobile, padding, user, width),
        BlogLink(isMobile, padding, user, width),
        BlogCreateLink(isMobile, padding, user, width),
        ViewBlogLink(isMobile, padding, user, width),
    ];
};
